import { render, staticRenderFns } from "./KilosHistoricos.vue?vue&type=template&id=686007a6"
import script from "./KilosHistoricos.vue?vue&type=script&lang=js"
export * from "./KilosHistoricos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports